// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","wrapper":"Home_wrapper__53Los"};